module.exports = {
  label: '文件历史',
  Details: '属性详情',
  view: '查看文件',
  PlsInput: '请输入',
  Query: '查询',
  fileName: '文件名',
  fileVersion: '版本',
  jobType: '文件类型',
  fileType: '文件格式',
  fileSize: '文件大小',
  createdBy: '创建人',
  createdDate: '创建日期',
  tagName: '属性名',
  tagValue: '属性值',
  Tips: '提示',
  DownloadFile: '是否保存文件？',
  Succeed: '下载成功',
  Failed: '下载失败',
  noFile: '没有历史记录。',
  Refresh: '刷新',
  Upload: '上传',
  Delete: '删除',
  BatchDownload: '批量下载',
  SendEmail: '发送邮件',
  TransferAllToFileHistory: '全部转存到文件历史',
  ingotUpload: 'ingot上传',
  ingotLog: 'ingot日志',
  preview: '预览',
  synchronization: '同步',
  cancelSynchronization: '取消同步',
  synchronizationState: '同步状态',
  operation: '操作',
  fileDownload: '文件下载',
  ExternalFileType: '外部文件类型',
  LastSyncTime: '最后同步时间',
  DisplayTicketFile: '显示小票文件',
  SendDestinationPortAgent: '发送目的港代理',
  SentDestinationPortAgent: '已发送目的港代理',
  ResetOneClickSend: '重置一键发送',
  FileCreator: '文件创建人',
  FileCreationDate: '文件创建日期',
  HasDeleted: '是否删除',
  SendSetOfProxyOrders: '发送套单代理',
  ProxyName: '代理名称',
  invoiceFlag: '是否发票',
  invoiceFlag_Yes: '发票',
  invoiceFlag_No: '非发票'
}
